export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export function globalFilter<T>(
  arr: T[],
  globalFilterText: string,
  fields?: Array<keyof T>,
): T[] {
  const data = arr.filter((i) => {
    const item = i as any;
    fields = fields || (Object.keys(item) as Array<keyof T>);
    for (const field of fields) {
      if (field === "optionHolderState") {
        const replacedString = item?.[field]
          .toString()
          .toLowerCase()
          .replace("_", " ");
        if (replacedString?.includes(globalFilterText.toLowerCase().trim())) {
          return true;
        }
      }
      if (
        item?.[field]
          .toString()
          .toLowerCase()
          .includes(globalFilterText.toLowerCase().trim())
      ) {
        return true;
      }
    }
    return false;
  });
  arr = data;
  return data;
}

export function convertDate(dateString: string) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, "0"); // local day
  const month = date.toLocaleString("en-US", { month: "short" }); // local month
  const year = date.getFullYear(); // local year

  let hours = date.getHours(); // local hours
  const minutes = date.getMinutes().toString().padStart(2, "0"); // local minutes
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours || 12; // the hour '0' should be '12'
  const hoursString = hours.toString().padStart(2, "0");

  return `${day}-${month}-${year} ${hoursString}:${minutes} ${ampm}`;
}
